import { sendObject } from './handler';

export type HandInExam = { type: 'handInExam'; sitId: number };

export const postHandInExam = async (sitId: number): Promise<void> =>
  sendObject({ type: 'handInExam', sitId });
